import React from 'react';
import {Link, Typography} from "@mui/material";
import Div from "@jumbo/shared/Div";

const Footer = () => {

    return (
        <Div sx={{
            py: 2,
            px: {xs: 1, sm: 2, md: 4, lg: 6},
            borderTop: 2,
            borderColor: 'divider',
            bgcolor: 'background.paper',
        }}>
            <Div sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography variant={"body1"} color={"text.primary"}>
                    Powered by{" "}
                    <Link href="https://xpit.cl" target="_blank" rel="noreferrer" color="inherit" underline="always">
                        Xpit
                    </Link>{" "}
                    © 2021
                </Typography>
            </Div>
        </Div>
    );
};

export default Footer;
